// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useState, useEffect} from 'react';

import ProjectNew from './ProjectNew'
import TranscriptNav from './TranscriptNav'
import ProjectSearchContainer from './ProjectSearchContainer'
import AnalysisDisplayContainer from './AnalysisDisplayContainer'
import DragDropTranscriptContainer from './DragDropTranscriptContainer'
import DragDropSurveyContainer from 'surveys/DragDropSurveyContainer';
import ProjectBody from './ProjectBody'
import RootBody from './RootBody'
import UserDisplay from './UserDisplay'
import CodeBookContainer from './CodeBookContainer'
import ProjectArchivePage from 'project_archives/ProjectArchivePage';
// Stores now managed by parent component
import SurveyPage from 'surveys/SurveyPage'
import SurveyResponsePage from 'surveys/SurveyResponsePage'
import SurveyUploadingContainer from 'surveys/SurveyUploadingContainer';

import {
  Switch,
  Route,
} from 'react-router-dom'
import ProjectChatContainer from 'chat/ProjectChatContainer';
import SurveyQuestionPage from 'surveys/SurveyQuestionPage';
import ReportsPage from './ReportsPage';
import TranscriptsDashboardPage from './TranscriptsDashboardPage';

const QualContent = (props) => {
  // onboardingState is now passed as a prop


  const componentWithHeight = (Component) => {
    return (otherProps) => {
      return (
        <Component
          projectID={props.projectID}
          transcriptID={props.transcriptID}
          codeID={props.codeID}
          hasEditPermission={props.hasEditPermission}
          onboardingState={props.onboardingState}
          {...otherProps}
        />
      );
    }
  }

  if (props.isArchived) {
    return <ProjectArchivePage isProjectOwner={props.isProjectOwner} />
  }

  return (
    <div style={{height: "100%", width: "100%"}}>
      <Switch>
        <Route
          exact
          path='/'
          component={RootBody}
        />
        <Route
          exact
          path='/projects'
          component={RootBody}
        />
        <Route
          exact
          path="/chat"
          component={RootBody}
        />
        <Route
          path='/projects/new'
          render={(match)=>(<ProjectNew />)}
        />
        <Route
          path='/projects/:projectID/search'
          render={componentWithHeight(ProjectSearchContainer)}
        />
        <Route
          path='/projects/:projectID/reports/:reportId?'
          render={componentWithHeight(ReportsPage)}
        />
        <Route
          path='/projects/:projectID/analysis'
          render={componentWithHeight(AnalysisDisplayContainer)}
        />
        <Route
          path='/projects/:projectID/codes/:codeID'
          render={componentWithHeight(CodeBookContainer)}
        />
        <Route
          path='/projects/:projectID/codes'
          render={componentWithHeight(CodeBookContainer)}
        />
        <Route
          path='/projects/:projectID/chat/:conversationID'
          render={componentWithHeight(ProjectChatContainer)}
        />
        <Route
          path='/projects/:projectID/chat'
          render={componentWithHeight(ProjectChatContainer)}
        />
        <Route
          path='/projects/:projectID/transcripts/new'
          render={componentWithHeight(DragDropTranscriptContainer)}
        />
        <Route
          exact
          path='/projects/:projectID/transcripts'
          render={componentWithHeight(TranscriptsDashboardPage)}
        />
        <Route
          path='/projects/:projectID/surveys/new/:csvFileID'
          render={componentWithHeight(SurveyUploadingContainer)}
        />
        <Route
          path='/projects/:projectID/surveys/new'
          render={componentWithHeight(DragDropSurveyContainer)}
        />
        <Route
          path='/projects/:projectID'
          component={ProjectBody}
        />
        <Route
          path='/transcripts/:transcriptID'
          render={componentWithHeight(TranscriptNav)}
        />
        <Route
          path='/surveys/:surveyID/survey_questions/:surveyQuestionID'
          render={componentWithHeight(SurveyPage)}
        />
        <Route
          path='/surveys/:surveyID'
          render={componentWithHeight(SurveyPage)}
        />
        <Route
          path='/survey_responses/:surveyResponseID'
          render={componentWithHeight(SurveyResponsePage)}
        />
        <Route
          path='/survey_questions/:surveyQuestionID'
          render={componentWithHeight(SurveyQuestionPage)}
        />
        <Route
          path='/users'
          component={UserDisplay}
        />
        <Route
          path='/'
          render={() => <h3>Choose a Project</h3>}
        />
      </Switch>
    </div>
  );
}

export default QualContent;
